module.exports = __webpack_public_path__ + "assets/img/icomoon.svg?8ee4075686fc3ed6660dfe61b3af1145";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.svg?i1bfht
// module id = 643
// module chunks = 0